import { getTelemetryClientConfig } from '@ms/yammer-telemetry-store';

import type { ResourceEntryType } from './types';

const ecsResourcePrefixes = [
  'https://ecs.office.com/config/v1/YammerClients',
  'https://gccmod.ecs.office.com/config/v1/YammerClients',
  'https://config.ecs.gov.teams.microsoft.us/config/v1/YammerClients',
];
const operationNameServerTimingKey = 'opName';
const requestIdServerTimingKey = 'xReqId';

const getValueFromServerTiming = (serverTiming: readonly PerformanceServerTiming[], name: string) => {
  const record = serverTiming?.find((timing) => timing.name === name);

  return record?.description;
};

type GetOperationNameFromServerTiming = (serverTiming: readonly PerformanceServerTiming[]) => string | undefined;
export const getOperationNameFromServerTiming: GetOperationNameFromServerTiming = (serverTiming) =>
  getValueFromServerTiming(serverTiming, operationNameServerTimingKey);

type GetRequestIdFromServerTiming = (serverTiming: readonly PerformanceServerTiming[]) => string | undefined;
export const getRequestIdFromServerTiming: GetRequestIdFromServerTiming = (serverTiming) =>
  getValueFromServerTiming(serverTiming, requestIdServerTimingKey);

const isGraphqlResourceEntry = ({ name }: PerformanceResourceTiming) => {
  const clientConfig = getTelemetryClientConfig();
  if (!clientConfig) {
    return false;
  }

  return name.startsWith(`${clientConfig.graphqlHost}/graphql`);
};

const isJavaScriptResourceEntry = ({ name }: PerformanceResourceTiming) => name.endsWith('.js');

const isCSSResourceEntry = ({ name }: PerformanceResourceTiming) => name.endsWith('.css');

const isFlightingResourceEntry = ({ name }: PerformanceResourceTiming) =>
  ecsResourcePrefixes.some((ecsResourcePrefix) => name.startsWith(ecsResourcePrefix));

const isImageResourceEntry = ({ name }: PerformanceResourceTiming) =>
  name.includes('api/v1/uploaded_files') &&
  (name.includes('preview') || name.includes('thumbnail')) &&
  name.includes('file_type=image');

type GetResourceEntryType = (resourceEntry: PerformanceResourceTiming) => ResourceEntryType;
export const getResourceEntryType: GetResourceEntryType = (resourceEntry) => {
  if (isGraphqlResourceEntry(resourceEntry)) {
    return 'GraphQL';
  }

  if (isJavaScriptResourceEntry(resourceEntry)) {
    return 'JavaScript';
  }

  if (isCSSResourceEntry(resourceEntry)) {
    return 'CSS';
  }

  if (isFlightingResourceEntry(resourceEntry)) {
    return 'Flighting';
  }

  if (isImageResourceEntry(resourceEntry)) {
    return 'Image';
  }

  return 'Unknown';
};
